const pom = {
  about: {
    aboutSection: "[data-testid='about-section']",
  },
  banners: {
    doubleCheckOrderBanner: "[data-testid='double-check-order-banner']",
    doubleCheckOrderText: "[data-testid='double-check-order-text']",
    notAcceptingOrderBanner: "[data-testid='not-accepting-order-banner']",
  },
  retailCart: {
    items: "[data-testid=retail-cart-items]",
    pickupTime: "[data-testid=pickup-time]",
    cartDrawer: "[data-testid='retail-cart']",
    cartItem: "[data-testid='retail-cart-item']",
  },
  checkout: {
    checkoutHeader: "[data-testid='checkout-header']",
    perkCardApplied: "[data-testid='perk-card-applied']",
    toolTipBox: "[data-testid='toolTipBox']",
    toolTipIcon: "[data-testid='toolTipIcon']",
    cardNumberInput: "[data-testid='card-number-input']",
    cardExpirationInput: "[data-testid='card-expiration-input']",
    cardCvcInput: "[data-testid='card-cvc-input']",
    bookAppointmentButton: "[data-testid='book-appointment-button']",
    checkoutPickupOrderTimeMessage:
      "[data-testid='checkout-pickup-order-time-message']",
    checkoutPerkSelection: "[data-testid='checkout-perk-selection']",
    checkoutNavigationReturnButton:
      "[data-testid='checkout-navigation-return-button']",
    totalAmount: "[data-testid='total-amount']",
    removeItemButton: "[data-testid='remove-item-button']",
    emptyCartMessage: "[data-testid='empty-cart-message']",
    checkoutSummaryHeader: "[data-testid='checkout-summary-header']",
    cofTile: "[data-testid='cof-tile']",
    cofCardBrand: "[data-testid='cof-card-brand']",
    cofCardLast4: "[data-testid='cof-card-last4']",
    cofAddCardLink: "[data-testid='cof-add-card-link']",
    saveCardDetailsModal: "[data-testid='save-card-modal']",
    updateCardDetailsModal: "[data-testid='update-card-modal']",
    cancellationPolicyCheckbox: "[data-testid='cancellation-policy-checkbox']",
    depositPolicyCheckbox: "[data-testid='deposit-policy-checkbox']",
  },
  customerProfile: {
    notCompleteCustomerInfoBanner:
      "[data-testid='not-complete-customer-info-banner']",
    customerProfileHeader: "[data-testid='customer-profile-header']",
    cancelAppointmentButton: "[data-testid='cancel-appointment-button']",
    appointmentStatus: "[data-testid='appointment-status']",
  },
  drawer: {
    continueToCheckoutCartButton:
      "[data-testid='continue-to-checkout-cart-button']",
    unavailableItemsBannerText: "[data-testid='unavailable-items-banner-text']",
    itemsAvailableAndAddedBannerText:
      "[data-testid='items-available-and-added-banner-text']",
    checkoutButton: "[data-testid='checkout-button']",
    reorderNeedsReAddItem: "[data-testid='reorder-needs-re-add-item']",
    reorderHardUnavailableItem: "[data-testid='reorder-hard-unavailable-item']",
  },
  confirmation: {
    confirmationHeading: "[data-testid='confirmation-heading']",
    keepBrowsingButton: "[data-testid='merchant-link-button']",
  },
  spinner: {
    overlaySpinner: "div[data-testid='regular-modal'][title='Loading']",
  },
  footer: {
    cloverFooter: "[data-testid='clover-footer']",
    googlePlayButton: "[data-testid='google-play-button']",
    appStoreButton: "[data-testid='app-store-button']",
    footer: "[data-testid='footer']",
    description: "[data-testid='footer-description']",
    contactInfo: "[data-testid='contact-info']",
    businessHours: "[data-testid='business-hours']",
  },
  general: {
    reactModalContent: "[data-testid='react-modal-content']",
    itemName: "[data-testid='item-name']",
  },
  giftCard: {
    addGiftCardButton: "[data-testid='add-gift-card-button']",
    giftCardAmountInput: "[data-testid='gift-card-amount-input']",
    buyThisForMyselfCheckbox: "[data-testid='buy-this-for-myself-checkbox']",
    formContainer: "[data-testid='form-container']",
    giftCardCartItem: "[data-testid='gift-card-cart-item']",
    giftCardAmount: "[data-testid='gift-card-amount']",
    giftCardMainContainer: "[data-testid='gift-card-main-container']",
    giftCardPageHeading: "[data-testid='gift-card-page-heading']",
    giftCardPageDescription: "[data-testid='gift-card-page-description']",
    personalMessageComponent: "[data-testid='personal-message-component']",
    recipientEmail: "[data-testid='recipient-email']",
    recipientInformationComponent:
      "[data-testid='recipient-information-component']",
    recipientName: "[data-testid='recipient-name']",
    navLink: "[data-testid='gift-card-navlink']",
    removeItem: "[data-testid='remove-giftcard-item']",
  },
  header: {
    merchantLogo: "merchant logo", // for alt attribute
    merchantLogoDataTestId: "[data-testid='merchant-logo']", // for data-testid
    merchantLogoAlt: `[alt="${"merchant logo"}"]`, // for cypress selector
    navigationBar: "[data-testid='navigation-bar']",
    headerContainer: "[data-testid='header-navigation-container']",
    cartNumber: "[data-testid='cart-number']",
    searchInputField: "[data-testid='input-search']",
    searchIcon: "[data-testid='search-icon']",
    searchCategoriesTypeaheadInput:
      '[data-testid="search-categories-typeahead-input"]',
    searchCategoriesTypeaheadOptions:
      '[data-testid="search-categories-typeahead-options"]',
    searchCategoriesTypeaheadEmptyMessage:
      '[data-testid="search-categories-typeahead-empty-message"]',
    searchCategoriesPanel: '[data-testid="search-categories-panel"]',
    merchantName: "[data-testid='merchant-name']",
    dismissCookieBanner: "[data-testid='dismiss-cookie-banner']",
    hamburgerButton: "[data-testid='hamburger-button']",
    navigationLinksContainer: "[data-testid='navigation-links-container']",
    navigationHorizontalScrollContainer:
      "[data-testid='navigation-horizontal-scroll-container']",
    navigationHorizontalScrollToggleButton:
      "[data-testid='navigation-horizontal-scroll-toggle-button']",
  },
  icons: {
    bulletPointIcon: "[data-testid='bullet-point-icon']",
    xIcon: "[data-testid='x icon']",
    doubleCheckOrderIcon: "[data-testid='double-check-order-icon']",
    minusIcon: "[data-testid='minus-icon']",
    plusIcon: "[data-testid='plus-icon']",
    profileIcon: "[data-testid='profile-icon']",
    sendCodeIcon: "[data-testid='send-code-icon']",
    serviceSummaryErrorIcon: "[data-testid='service-summary-error-icon']",
    trashIcon: "[data-testid='trash-icon']",
    accountIcon: "[data-testid='account-icon']",
    addToCartIcon: "[data-testid='add-to-cart-icon']",
    chevronUpIcon: "[data-testid='chevron-up-icon']",
    leftArrowIcon: "[data-testid='left-arrow-icon']",
    rightArrowIcon: "[data-testid='right-arrow-icon']",
  },
  itemModal: {
    name: ".ReactModalPortal [data-testid=item-modal-name]",
    totalPrice: ".ReactModalPortal [data-testid=item-modal-total-price]",
    modifierGroupDisplay:
      ".ReactModalPortal [data-testid=modifier-group-display]",
    description: ".ReactModalPortal [data-testid=item-modal-description]",
    addToCartButton: "[data-testid=item-modal-add-to-cart-button]",
  },
  landingPage: {
    heroSection: "[data-testid='hero-section']",
    heroImage: "[data-testid='hero-image']",
    heroHeadline: "[data-testid='hero-headline']",
    heroSectionButton: "[data-testid='hero-section-button']",
    landingProducts: "[data-testid='landing-products']",
    productListing: "[data-testid='item-list']",
    productCardName: "[data-testid='product-card-name']",
    productCardImage: "[data-testid='product-card-image']",
    orderTypeDropdown: "[data-testid='order-type-dropdown']",
    scheduledOrderDropdown: "[data-testid='scheduled-order-dropdown']",
    cartIcon: "[data-testid='cart-icon']",
    productLink: "[data-testid^='product-link-']",
    addToOrderButton: "[data-testid='add-to-order-button']",
    productsSkeleton: "[data-testid='products-skeleton']",
    itemPageSkeleton: "[data-testid='item-page-skeleton']",
    heroTitle: "[data-testid='hero-title']",
    heroDescription: "[data-testid='hero-description']",
    categoriesSection: "[data-testid='navigation-links-container']",
    category: (categoryName: string) =>
      `[data-testid='category-${categoryName}']`,
    itemsSection: "[data-testid='items-section']",
    item: (itemName: string) => `[data-testid='item-${itemName}']`,
    servicesSection: "[data-testid='services-section']",
    bookNowButton: "[data-testid='book-now-button']",
    viewMenuButton: "[data-testid='view-menu-button']",
    aboutUsSection: "[data-testid='about-us-section']",
    aboutUsTitle: "[data-testid='about-us-title']",
    aboutUsDescription: "[data-testid='about-us-description']",
    aboutUsImage: "[data-testid='about-us-image']",
    contactUsSection: "[data-testid='contact-us-section']",
    contactUsTitle: "[data-testid='contact-us-title']",
    contactUsDescription: "[data-testid='contact-us-description']",
    contactUsForm: "[data-testid='contact-us-form']",
    contactUsMap: "[data-testid='contact-us-map']",
    gallerySection: "[data-testid='gallery-section']",
    galleryTitle: "[data-testid='gallery-title']",
    galleryDescription: "[data-testid='gallery-description']",
    galleryImages: "[data-testid='gallery-images']",
    testimonialsSection: "[data-testid='testimonials-section']",
    testimonialsTitle: "[data-testid='testimonials-title']",
    testimonialsDescription: "[data-testid='testimonials-description']",
    testimonials: "[data-testid='testimonials']",
    viewAllFeaturedCategoryButton: "[data-testid='view-all-button']",
  },
  loginInfoModal: {
    otpInput: "[data-testid='otp-input']",
    phoneInput: "[data-testid='phone-input']",
  },
  merchantFooter: {
    merchantFooter: "[data-testid='merchant-footer']",
    businessLocationsSection: "[data-testid='business-locations-section']",
    operatingHoursSection: "[data-testid='operating-hours-section']",
    linksSection: "[data-testid='links-section']",
    map: "[data-testid='google-map']",
    socialMediaLinks: "[data-testid='social-media-links']",
    customerContactEmail: "[data-testid='customer-contact-email']",
    facebookIcon: "[data-testid='facebook-icon']",
    instagramIcon: "[data-testid='instagram-icon']",
  },
  modals: {
    loginModalCloseButton: "[data-testid='login-modal-close-button']",
    secondaryButton: "[data-testid='secondary-button']",
    closeButton: "[data-testid='close-button']",
    loginModalSwitchInput: "[data-testid='login-modal-switch-input-method']",
    editAddressModal: "[data-testid='edit-address-modal']",
    deliveryErrorModal: "[data-testid='delivery-error-address-modal']",
    loginModalGuestCheckoutButton:
      "[data-testid='login-modal-guest-checkout-button']",
  },
  navigationBar: {
    aboutSection: "[data-testid='about-section']",
    selectedCategories: "[data-testid='selected-categories']",
    moreDropdown: "[data-testid='more-dropdown']",
    servicesLink: "[data-testid='services-navlink']",
    shopLink: "[data-testid='shop-navlink']",
    navigationBarPerksButton: "[data-testid='navigation-perks-button']",
    navigationBarUserUtilityPanel:
      "[data-testid='navigation-bar-user-utility-panel']",
  },
  secondaryServicesNavigationBar: {
    container: "[data-testid='secondary-services-navigation-bar']",
  },
  onloadScheduledOrderModal: {
    modal: "[data-testid='onload-scheduled-order-modal']",
  },
  orders: {
    noOrdersInProgress: "[data-testid='no-orders-in-progress']",
    currentOrdersList: "[data-testid='current-orders-list']",
    currentOrdersHeading: "[data-testid='current-orders-heading']",
    pastOrdersHeading: "[data-testid='past-orders-heading']",
    pastOrdersList: "[data-testid='past-orders-list']",
    entryOrderId: "[data-testid='entry-order-id']",
    entryOrderDate: "[data-testid='entry-order-date']",
    paymentStatusText: "[data-testid='payment-status-text']",
    fulfillmentStatusText: "[data-testid='fulfillment-status-text']",
    viewReceiptButton: "[data-testid='view-receipt-button']",
    orderAgainButton: "[data-testid='order-again-button']",
  },
  orderTypeOption: (type: string) =>
    `[data-testid='order-type-option-${type}']`,
  products: {
    productPrice: "[data-testid='product-price']",
    singleProduct: "[data-testid='single-product']",
    productDescription: "[data-testid='product-description']",
    giftCardImage: "[data-testid='gift-card-image']",
    serviceDuration: "[data-testid='service-duration']",
  },
  policy: {
    policyContent: "[data-testid='policy-content']",
  },
  restaurantCart: {
    items: "[data-testid='restaurant-cart-items']",
    cartDrawer: "[data-testid='restaurant-cart-drawer']",
    itemName: "[data-testid='restaurant-cart-item-name']",
    itemPrice: "[data-testid='restaurant-cart-item-price']",
  },
  retailCategories: {
    categoryHeader: "[data-testid='category-header']",
    sortDropdown: "[data-testid='sort-dropdown']",
    sortOptions: {
      alphabeticalAZ: "[data-testid='sort-option-alphabetical-asc']",
      alphabeticalZA: "[data-testid='sort-option-alphabetical-desc']",
      priceLowHigh: "[data-testid='sort-option-price-asc']",
      priceHighLow: "[data-testid='sort-option-price-desc']",
    },
    pagination: "[data-testid='pagination']",
    paginationText: "[data-testid='pagination-text']",
  },
  scheduler: {
    avatar: "[data-testid='avatar']",
  },
  scanToOrder: {
    itemsAddedToCartBanner: "[data-testid='items-added-to-cart-banner']",
    runningTabsWelcomeModal: "[data-testid='running-tabs-welcome-modal']",
    runningTabsWelcomeModalHeader:
      "[data-testid='running-tabs-welcome-modal-header']",
    runningTabsWelcomeModalText:
      "[data-testid='running-tabs-welcome-modal-text']",
    scanToOrderCartHeader: "[data-testid='scan-to-order-cart-header']",
    scanToOrderCartTableInfo: "[data-testid='scan-to-order-cart-table-info']",
    sendToKitchenButton: "[data-testid='send-to-kitchen-button']",
    tableInfoItem: "[data-testid='table-info-item']",
    cartItemModifierList: "[data-testid='cart-item-modifier-list']",
  },
  serviceModal: {
    price: "[data-testid=service-modal-price]",
    bookButton: "[data-testid=book-service-button]",
    description: "[data-testid=service-modal-description]",
  },
  verifyEmail: {
    verifyEmailHeader: "[data-testid='verify-email-header']",
  },
  itemPage: {
    name: "[data-testid='item-name']",
    price: "[data-testid='item-price']",
    description: "[data-testid='item-description']",
    addToCartButton: "[data-testid='add-to-cart-button']",
    variants: "[data-testid='item-variants']",
    ageRestrictionWarning: "[data-testid='age-restriction-warning']",
    modifierGroupName: "item-page-modifier-group-name",
    modifierInput: "[data-testid^='modifier-input-']", // Use starts-with selector
    quantityStepper: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}']`,
    quantityInput: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}'] input`,
    incrementButton: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}'] button:last-child`,
    decrementButton: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}'] button:first-child`,
    ruleLabel: (modifierGroupId?: string) =>
      `[data-testid='modifier-group-rule-${modifierGroupId}']`,
    modifierPrice: "[data-testid^='modifier-price-']",
  },
  steppers: {
    quantityStepper: "[data-testid='quantity-stepper-']",
    itemQuantityStepper: "[data-testid='quantity-stepper-item']",
  },
  services: {
    timeSlot: "[data-testid='time-slot']",
    scheduleAppointmentButton: "[data-testid='schedule-appointment-button']",
    serviceSummaryContinue: "[data-testid='service-summary-continue']",
    serviceSummaryCart: "[data-testid='service-cart-items']",
    serviceSummary: "[data-testid='service-summary']",
  },
  skeletons: {
    navBarSkeleton: "[data-testid='nav-bar-skeleton']",
    iconSkeleton: "[data-testid='icon-loading']",
    allSkeletons: "[data-testid$='-skeleton']",
  },
  utilities: {
    buttonByText: (text: string) => `button:contains('${text}')`,
    linkByText: (text: string) => `a:contains('${text}')`,
  },
  categoryButton: {
    categoryButtonContainer: "[data-testid='category-button-container']",
    categoryButtonText: "[data-testid='category-button-text']",
    categoryButtonIcon: "[data-testid='category-button-icon']",
  },
  mobileNavigationBar: {
    mobileNavBarContainer: "[data-testid='mobile-nav-bar-container']",
    mobileNavBarBackdrop: "[data-testid='mobile-nav-bar-backdrop']",
    mobileNavBarCloseButton: "[data-testid='mobile-nav-bar-close-button']",
    mobileMenuLinksContainer: "[data-testid='mobile-menu-links-container']",
  },
  restaurantMenu: {
    menuPageItem: "[data-testid='restaurant-menu-page-item']",
  },
  searchPage: {
    emptyResults: "[data-testid='results-empty']",
    searchResultsHeader: "[data-testid='search-results-header']",
  },
  accessibilityIds: {
    checkoutSummaryButton: "checkout-summary-button",
    chooseYourCountryTitle: "choose-your-country",
    businessHours: "business-hours",
    currentOrdersHeading: "current-orders-heading",
    pastOrdersHeading: "past-orders-heading",
    upcomingBookingsHeading: "upcoming-bookings-heading",
    pastBookingsHeading: "past-bookings-heading",
    checkoutSummaryCount: "[data-testid='checkout-summary-count']",
    secondaryNavStart: "secondary-nav-start",
  },
  deliveryEstimateBanner: {
    awayFromFreeDelivery: "[data-testid='away-from-free-delivery']",
    minimumDelivery: "[data-testid='minimum-delivery']",
    addToCart: "[data-testid='add-items-to-cart']",
    freeDelivery: "[data-testid='free-delivery']",
  },
  notFoundPage: {
    title: "[data-testid='not-found-page-title']",
  },
  errorPage: {
    title: "[data-testid='error-page-title']",
  },
  localStorage: {
    serviceCart: "serviceCart",
  },
};

export default pom;
